import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Button from "../../Components/Button";
import { useNavigate } from "react-router-dom";
import ButtonTestFree from "../../Components/ButtonTestFree";

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  border-radius: 16px;
  overflow: hidden;

  /* borda sutil pra destacar da thumb */
  border: 1px solid rgba(0, 0, 0, 0.08);

  /* sombra pika porém chique */
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25), 0 4px 10px rgba(0, 0, 0, 0.15);

  iframe {
    width: 100%;
    height: 500px;
    border: 0;
    display: block;
  }

  @media (max-width: 768px) {
    iframe {
      height: 260px;
    }
  }
`;

const Video = () => {
  const navigate = useNavigate();

  const goToVideos = () => {
    navigate("/tutorials");
  };
  return (
    <Container
      id="section-10"
      style={{
        textAlign: "center",
        paddingBottom: "40px",
        marginTop: "-20px",
      }}
    >
      <ButtonTestFree />
      <Row
        lg="1fr"
        sm="1fr"
        style={{ justifyContent: "center", width: "100%" }}
      >
        <VideoWrapper>
          <iframe
            src="https://www.youtube.com/embed/R5Yhk1jW4ww"
            title="Alfred Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoWrapper>
        <Button
          style={{
            maxWidth: "200px",
            margin: "40px auto",
            color: '#000000'
          }}
          onClick={goToVideos}
        >
          Ver todos os vídeos
        </Button>
      </Row>
    </Container>
  );
};

export default Video;
